"use strict";

var debug = require("debug")("knack.formatter.formatters.address");

/**
 * @alias "formatters.address"
 * @param {Object} value Value to be formatted
 * @param {String} value.street
 * @param {String} value.city
 * @param {String} value.state
 * @param {String} value.zip
 * @param {String} [value.country] Only shown if `addrFormat.format` === 'international_country'
 * @param {Object} [addrFormat] Format options for presenting the address, used for int'l addresses
 * @param {String} [addrFormat.format] Flag to add additional information to return value, valid values: international_country
 * @param {String} [responseFormat] `html` changes separator to \<br/>, while everything else uses a space
 * @return {String}
 */
var addressFormatter = function addressFormatter(value, addrFormat, responseFormat) {
  responseFormat = responseFormat || "html";
  var output = "";
  if (!value || !value.street && !value.city && !value.state && !value.zip && !value.country) {
    return output;
  }
  var divider = responseFormat === "html" ? "<br />" : " ";
  if (value.street) {
    output += value.street;
  }
  if (value.street2) {
    if (value.street) {
      output += divider;
    }
    output += value.street2;
  }
  if (value.street || value.street2) {
    output += divider;
  }
  if (value.city) {
    output += "".concat(value.city, ", ");
  }
  if (value.state) {
    output += "".concat(value.state, " ");
  }
  if (value.zip) {
    output += value.zip;
  }
  if (value.country && addrFormat && addrFormat.format && addrFormat.format === "international_country") {
    output += divider + value.country;
  }
  return output;
};
module.exports = addressFormatter;